import {Group} from "features/model/types/groups/groupsSchema";
import React, {FC} from "react";
import {Link, NavLink} from "react-router-dom";
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-table/array.svg';
import {useAppSelector} from "common/hook";
import {TestTakeItem} from "features/model/types/test/test-student/test-take/testTakeShema";


interface IActsItemProps {
    test: TestTakeItem;
}

export const StudentTestItems = ({test}: IActsItemProps) => {
    const statusText = test.status === 'done' ? 'Пройден' : test.status === 'notDone' ? 'Не пройден' : 'Ожидает выполнения';
    const userId = useAppSelector((state) => state.profile.data?.id);

    return (
        <div className="row">
            <div className="col test-col auto-width full-width-mobile">
                <span className="col-title">Тест</span>

                <NavLink to={`/test/${test.id}${test.status === 'done' ? `/view-answer/${userId}` : ''}`}>
                    {test.title}
                </NavLink>{" "}


            </div>
            <div className="col group-col full-width-mobile">
                <span className="col-title">Занятие</span>

                <NavLink to={`/groups/${test.lesson.groupId}/lessons/${test.lesson.id}`}>{test.lesson.title}</NavLink>

            </div>
            <div className="col status-col full-width-mobile">
                <span className="col-title">Статус</span>
                <p className={`status-item ${test.status === 'done' ? 'done' : test.status === 'notDone' ? 'not-done' : 'waiting'}`}>
                    {statusText}
                </p>
            </div>

            <NavLink to={`/test/${test.id}${test.status === 'done' ? `/view-answer/${userId}` : ''}`}>
                <div className="col btn-link-col">
                        <span className="circle-arrow-btn">
                            <ArrayIcon/>
                        </span>
                </div>
            </NavLink>{" "}

        </div>
    );
};
